
export default function() {
    if (document.getElementById("gs-program-internal-abstract-edit-form")) {
    }
}